import { useScrollAnimation } from '../hooks/useScrollAnimation';

export const AnimatedOnScroll = ({
  children,
  animation = 'fade-up',
  duration = 600,
  delay = 0,
  threshold = 0.1,
  once = true,
  className = '',
  style = {},
  customStartStyles = {},
  customEndStyles = {},
}) => {
  const ref = useScrollAnimation({
    animation,
    duration,
    delay,
    threshold,
    once,
    customStartStyles,
    customEndStyles,
  });

  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  );
};